import { GET_CLASS_ACTIVITIES } from '~/graphql/queries/classActivities'

const actionTypes = {
  GET_CLASS_ACTIVITIES: 'GET_CLASS_ACTIVITIES',
}

const mutationTypes = {
  SET_FETCHING_CLASS_ACTIVITIES: 'SET_FETCHING_CLASS_ACTIVITIES',
  SET_CURRENT_CLASS_ACTIVITIES: 'SET_CURRENT_CLASS_ACTIVITIES',
}

export const state = () => ({
  fetchingClassActivities: true,
  currentClassActivities: [],
})

export const mutations = {
  [mutationTypes.SET_FETCHING_CLASS_ACTIVITIES](state, fetchingClassActivities) {
    state.fetchingClassActivities = fetchingClassActivities
  },
  [mutationTypes.SET_CURRENT_CLASS_ACTIVITIES](state, currentClassActivities) {
    state.currentClassActivities = currentClassActivities
  },
}

export const actions = {
  async [actionTypes.GET_CLASS_ACTIVITIES]({ commit }, courseId) {
    commit(mutationTypes.SET_FETCHING_CLASS_ACTIVITIES, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: GET_CLASS_ACTIVITIES,
        fetchPolicy: 'no-cache',
        variables: { courseId },
      })
      commit(mutationTypes.SET_CURRENT_CLASS_ACTIVITIES, data.academyClassActivities.data)
      commit(mutationTypes.SET_FETCHING_CLASS_ACTIVITIES, false)
      return { data, success: true }
    } catch (error) {
      console.error('GET_ALL_TRAINERS', error)
      return { error, success: false }
    }
  },
}

export const getters = {
  fetchingClassActivities: (state) => state.fetchingClassActivities,
  currentClassActivities: (state) => state.currentClassActivities,
}
